import { findIndex } from "lodash"
//import sendxAPI from '../../../xAPI'

const templateState = {
  id: -1,
  type: null,
  open: false,
  description: "",
};

export function TipBoxReducer(state = { tipBoxes: [] }, action) {
  let currentTipBox;
  let protocolSection = state.protocolSection;

  if (action.payload === undefined) {
      return state;
  }

  if (action.type !== "CREATE_TIP_BOX" && !action.type.includes("@redux")) {
      if(action.payload.hasOwnProperty("id")){
        if(state.protocolSection.scene.apparatus.hasOwnProperty("tipBoxes")){
          currentTipBox = state.protocolSection.scene.apparatus.tipBoxes[findIndex(state.protocolSection.scene.apparatus.tipBoxes, { id: action.payload.id })]
        }
      }
  }

  switch (action.type) {

        case 'CREATE_TIP_BOX':

          //Create new obj from template state
          let newObj = { ...templateState, ...action.payload.props }

          if(protocolSection.scene.apparatus.hasOwnProperty("tipBoxes")){
            protocolSection.scene.apparatus.tipBoxes = [ ...protocolSection.scene.apparatus.tipBoxes, newObj ]
          } else {
            protocolSection.scene.apparatus.tipBoxes = [newObj]
          }

          return { ...state, ...{
            protocolSection: protocolSection
          } }

        case 'TIP_BOX_OPEN':

            // xAPI statement
            // sendxAPI({
            //   // Type of statement
            //   verb: {
            //     description: (action.payload.open)?"opened":"closed",
            //     address: (action.payload.open)?"https://w3id.org/xapi/dod-isd/verbs/opened":"https://w3id.org/xapi/dod-isd/verbs/closed"
            //   },
            //   // Where the action occured
            //   context: currentTipBox.type + " TipBox",
            //   // Result of the action
            //   result: {
            //     success: true,
            //     response: action.payload.open
            //   }
            // })

            currentTipBox.open = action.payload.open
            protocolSection.scene.apparatus.tipBoxes[findIndex(state.tipBoxes, { id: action.payload.id })] = currentTipBox

            return { ...state, ...{
              protocolSection: protocolSection
            } }

          case "UNDO":
              //Payload = {lastState}

              if (action.payload.lastState !== null) {

                protocolSection.scene.apparatus.tipBoxes = action.payload.lastState.scene.apparatus.tipBoxes

                return { ...state, ...{
                  protocolSection: protocolSection
                } }

              } else {
                return state;
              }

        default:
            return state;
    }
}
